
import { i18nHelper } from '@it-common/lbp_common'
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
XHeader
},
props: {
title: {
type: String,
default: ''
}
},
data () {
return {
name: 'onboard-header',
backText: i18nHelper.getLocale() === 'zh' ? '返回' : 'Back',
language: i18nHelper.getLocale() === 'zh' ? '英  文' : 'Chinese'
}
},
created () {
if (this.$route.query.locale === 'en') {
i18nHelper.setLocale('en')
this.backText = 'Back'
this.language = 'Chinese'
this.$emit('changeIsZH', false)
} else if (this.$route.query.locale === 'zh') {
i18nHelper.setLocale('zh')
this.backText = '返回'
this.language = '英  文'
this.$emit('changeIsZH', true)
} else {
if (i18nHelper.getLocale() === 'en') {
i18nHelper.setLocale('en')
this.backText = 'Back'
this.language = 'Chinese'
this.$emit('changeIsZH', false)
} else {
i18nHelper.setLocale('zh')
this.backText = '返回'
this.language = '英  文'
this.$emit('changeIsZH', true)
}
}
},
methods: {
historyBack () {
if (this.$route.name === 'onboard.preview' && this.$route.query.back === 1) {
this.$router.push({ name: 'onboard.code', query: { id: this.$route.query.id } })
return false
} else if (this.$route.name === 'onboard.code') {
window.close()
return false
} else {
history.go(-1)
}
},
changeI18n () {
if (i18nHelper.getLocale() === 'zh') {
i18nHelper.setLocale('en')
this.backText = 'Back'
this.language = 'Chinese'
this.$emit('changeIsZH', false)
} else {
i18nHelper.setLocale('zh')
this.backText = '返回'
this.language = '英  文'
this.$emit('changeIsZH', true)
}
this.$refs.btn1.$el.innerText = this.language
},
mounted () {
i18nHelper.loadLanguagePack(4159)
}
}
}



// WEBPACK FOOTER //
// ./src/components/OnboardHeader.vue